// initialize client here to make sure we use configured store
import Client from 'utils/webrtc/Client';

export { Client };
export const RTCClient = new Client();

export * from './types';
